export default "__VITE_PUBLIC_ASSET__0c33a96a__"